import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { memo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { settingsButton, settingsButtonSelected } from "./classNames";
import { optionShape } from "./propTypes";
var SettingsButton = memo(function (_ref) {
  var property = _ref.property,
      _ref$option = _ref.option,
      optionLabel = _ref$option.label,
      optionValue = _ref$option.value,
      value = _ref.value,
      setValue = _ref.setValue,
      children = _ref.children;

  var onClick = function onClick() {
    setValue(property, optionValue);
  };

  var isSelected = optionValue === value;
  return children({
    onClick: onClick,
    isSelected: isSelected,
    label: optionLabel,
    value: optionValue,
    className: cx(settingsButton, _defineProperty({}, settingsButtonSelected, isSelected))
  });
});
SettingsButton.propTypes = {
  property: PropTypes.string.isRequired,
  option: optionShape.isRequired,
  value: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
  children: PropTypes.func.isRequired
};
export default SettingsButton;